export const API_NAME = `${process.env.REACT_APP_AWS_NAMESPACE}-cms-portal-lambda`;